import React from 'react';
import styled from 'styled-components';
import tokenPocketImg from 'assets/images/partner/tokenpocket.png';
import coinmarketcapImg from 'assets/images/partner/coinmarketcap.png';
import coingeckoImg from 'assets/images/partner/coingecko.png';
import dappradarImg from 'assets/images/partner/dappradar.png';
import bscscanImg from 'assets/images/partner/bscscan.png';
import dappImg from 'assets/images/partner/dapp.com.png';
import { Grid } from '@material-ui/core';

const HunnyPartner: React.FC = () => {
  return (
    <StyledNav>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StyledLink
            target="_blank"
            href="https://coinmarketcap.com/currencies/pancake-hunny/"
          >
            <StyledPartnerImg src={coinmarketcapImg} />
          </StyledLink>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StyledLink
            target="_blank"
            href="https://www.coingecko.com/en/coins/pancake-hunny"
          >
            <StyledPartnerImg src={coingeckoImg} />
          </StyledLink>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StyledLink>
            <StyledPartnerImg src={tokenPocketImg} />
          </StyledLink>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StyledLink
            target="_blank"
            href="https://www.dapp.com/app/pancake-hunny"
          >
            <StyledPartnerImg src={dappImg} />
          </StyledLink>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StyledLink
            target="_blank"
            href="https://bscscan.com/token/0x565b72163f17849832a692a3c5928cc502f46d69"
          >
            <StyledPartnerImg src={bscscanImg} />
          </StyledLink>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <StyledLink
            target="_blank"
            href="https://dappradar.com/binance-smart-chain/defi/pancake-hunny"
          >
            <StyledPartnerImg src={dappradarImg} />
          </StyledLink>
        </Grid>
      </Grid>
    </StyledNav>
  );
};

const StyledNav = styled.nav`
  align-items: center;
  display: flex;
  width: 100%;
  @media (max-width: 767px) {
    flex-direction: column;
    width: 100%;
  } ;
`;

const StyledPartnerImg = styled.img`
  height: 100%;
  max-height: 30px;
`;

const StyledLink = styled.a`
  box-sizing: border-box;
  color: ${(props) => props.theme.color.grey[200]};
  font-size: 14px;
  opacity: 0.8;
  font-weight: normal;
  padding: 16px 8px;
  text-decoration: none;

  flex-grow: 1;
  display: flex;
  justify-content: center;
`;

export default HunnyPartner;
